import { RouteObject } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { lazyWithRetry } from "@/utils/lazyWithRetry";

const SerpImpactPublic = lazyWithRetry(() => import("@/pages/serp/SerpImpactPublic"));
const NetworkOperations = lazyWithRetry(() => import("@/pages/serp/NetworkOperations"));
const SelfServiceOnboarding = lazyWithRetry(() => import("@/pages/serp/SelfServiceOnboarding"));
const ParallelReviewWorkspace = lazyWithRetry(
  () => import("@/pages/serp/ethics/ParallelReviewWorkspace"),
);
// GBTMaturityTracker removed — WHO GBT country rating moved to UmojaReg.
// See src/routes/umojareg.redirects.ts (/serp/ra/gbt -> /umoja/gbt/tracker).
const ADRReportingConsole = lazyWithRetry(
  () => import("@/pages/serp/pv/ADRReportingConsole"),
);
const SignalDetection = lazyWithRetry(
  () => import("@/pages/serp/pv/SignalDetection"),
);
const AfriVigilanceBridge = lazyWithRetry(
  () => import("@/pages/serp/pv/AfriVigilanceBridge"),
);

/**
 * SERP-01 (EDCTP3-funded) route group.
 * - /serp/impact is public (aggregate only)
 * - /serp/onboarding is gated to authenticated users
 * - all operational consoles are gated to authenticated users with
 *   serp_admin / pv_focal / nra_focal / rec_focal roles enforced at RLS layer.
 */
export const serpRoutes: RouteObject[] = [
  { path: "/serp/impact", element: <SerpImpactPublic /> },
  {
    path: "/serp/onboarding",
    element: (
      <ProtectedRoute>
        <SelfServiceOnboarding />
      </ProtectedRoute>
    ),
  },
  {
    path: "/serp/network",
    element: (
      <ProtectedRoute>
        <NetworkOperations />
      </ProtectedRoute>
    ),
  },
  {
    path: "/serp/ethics/parallel-review",
    element: (
      <ProtectedRoute>
        <ParallelReviewWorkspace />
      </ProtectedRoute>
    ),
  },
  // /serp/ra/gbt -> umojareg.org/umoja/gbt/tracker (handled by renderUmojaregRedirects)
  {
    path: "/serp/pv/adr",
    element: (
      <ProtectedRoute>
        <ADRReportingConsole />
      </ProtectedRoute>
    ),
  },
  {
    path: "/serp/pv/signals",
    element: (
      <ProtectedRoute>
        <SignalDetection />
      </ProtectedRoute>
    ),
  },
  {
    path: "/serp/pv/afrivigilance",
    element: (
      <ProtectedRoute>
        <AfriVigilanceBridge />
      </ProtectedRoute>
    ),
  },
];
